import { CustomPdfAppearanceTemplateType } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { customPdfAppearanceTemplateQueryKeys } from "../query-keys";

const getMyPdfAppearanceTemplates =
  async (): Promise<CustomPdfAppearanceTemplateType[]> => {
    const { data } = await privateAxios.get<CustomPdfAppearanceTemplateType[]>(
      `/custom-appearance/pdf-template`
    );
    return data ?? [];
  };

export const useGetMyPdfAppearanceTemplatesQuery = () => {
  return useQuery({
    queryKey: customPdfAppearanceTemplateQueryKeys.all,
    queryFn: getMyPdfAppearanceTemplates,
  });
};
